import React from 'react';
import BanglaNatok from '../Home/BanglaNatok/BanglaNatok';

const Natok = () => {
    return (
        <div className='movie' style={{ marginTop: '100px' }}>
            <BanglaNatok />
        </div>
    );
};

export default Natok;